import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Input } from "../components/ui/input";
import { useAuth, formatApiErrorDetail } from "../lib/auth";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  const field = "h-12 rounded-none border-0 border-b border-neutral-300 px-0 shadow-none focus-visible:ring-0 focus-visible:border-neutral-950";
  return (
    <main className="flex min-h-screen items-center justify-center bg-[hsl(var(--stone))] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-10 md:p-14" data-testid="admin-login-form">
        <Link to="/"><img src="/logo-black.png" alt="Lux Veritae" className="mx-auto h-24 w-auto" /></Link>
        <p className="kicker mt-8 text-center">Private Inbox</p>
        <label className="mt-10 block"><span className="text-[10px] uppercase tracking-[0.25em] text-neutral-500">Email</span>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={field} data-testid="admin-email-input" /></label>
        <label className="mt-6 block"><span className="text-[10px] uppercase tracking-[0.25em] text-neutral-500">Password</span>
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={field} data-testid="admin-password-input" /></label>
        {error && <p className="mt-5 text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-ink mt-10 w-full disabled:opacity-60" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign In"}</button>
      </form>
    </main>
  );
}
